import React, { createRef } from 'react';
import { Image, Modal, Button, Icon } from 'semantic-ui-react';
import './PhotoSlideShow.less'

const initialState = { rotationNumber: 1, scale: 1, zoomoutDisabled: true }
class PhotoSlideShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.imageContainerRef = createRef();
    this.imageRef = createRef();
    this.lastMousePosition = { x: 0, y: 0 };
    this.currentPosition = { x: 0, y: 0 };
  }

  closeModal() {
    this.props.setOpenedIndex(-1);
    this.setState({ rotationNumber: 1 });
  }

  nextImage() {
    const { openedImageIndex } = this.props;
    const { images } = this.props;
    if (openedImageIndex < (images.length - 1)) {
      this.props.setOpenedIndex((openedImageIndex + 1))
    }
    this.setState({ rotationNumber: 1 });
  }

  previousImage() {
    const { openedImageIndex } = this.props;
    if (openedImageIndex > 0) {
      this.props.setOpenedIndex((openedImageIndex - 1))
    }
    this.setState({ rotationNumber: 1 });
  }

  handleOnRotationClick = () => {
    let nextRotationNumber = ++this.state.rotationNumber;
    if (nextRotationNumber > 4) {
      nextRotationNumber = 1;
    }
    this.setState({ rotationNumber: nextRotationNumber }, () => {
      this.imageRef.current.style.transform = this.translateRotateToSkew(0, 0);
      const currentPositionX = this.currentPosition.x;
      const currentPositionY = this.currentPosition.y;

      this.currentPosition.x = currentPositionY;
      this.currentPosition.y = currentPositionX;
    });

  }

  translateRotateToSkew = (moveX, moveY) => {
    if (this.state.rotationNumber == 1) {
      return `matrix(${this.state.scale}, 0,0, ${this.state.scale}, ${moveX} , ${moveY})`;
    }
    else if (this.state.rotationNumber == 2) {
      return `matrix(0, ${this.state.scale}, ${this.state.scale * -1}, 0, ${moveX} , ${moveY})`;
    }

    else if (this.state.rotationNumber == 3) {
      return `matrix(${this.state.scale * -1}, 0, 0, ${this.state.scale * -1}, ${moveX} , ${moveY})`;
    }

    else if (this.state.rotationNumber == 4) {
      return `matrix(0, ${this.state.scale * -1}, ${this.state.scale}, 0, ${moveX} , ${moveY})`;
    }
  }

  handleZoomIn = () => {
    this.setState({ scale: this.state.scale + 1, zoomoutDisabled: false }, () => {
      this.imageRef.current.style.transform = this.translateRotateToSkew(0, 0);
    })


  }

  handleZoomOut = () => {
    if (this.state.scale > 1) {
      this.setState({ scale: this.state.scale - 1 }, () => {
        this.imageRef.current.style.transform = this.translateRotateToSkew(0, 0);
        if (this.state.scale == 1) {
          this.setState({ zoomoutDisabled: true });
        }
      })
    }

  }




  onModalMount = () => {
    console.log(this.imageRef);
    console.log(this.imageContainerRef.current.offsetLeft);
    console.log(this.imageContainerRef.current.offsetTop);
  }

  onImageContainerMouseDown = (e) => {
    this.setState({ imageMove: true });
    this.lastMousePosition = { x: e.pageX, y: e.pageY };
  }

  onImageContainerMouseUp = (e) => {
    this.setState({ imageMove: false })

  }

  onImageContainerMouseMove = (e) => {
    if (this.state.imageMove) {
      let offset = { x: e.pageX - this.lastMousePosition.x, y: e.pageY - this.lastMousePosition.y };

      if (this.state.scale > 1) {
        if ((this.state.rotationNumber == 1 || this.state.rotationNumber == 3)) {
          if (this.currentPosition.x + offset.x < ((this.state.scale - 1) / 2) * this.imageRef.current.clientWidth &&
            this.currentPosition.x + offset.x > (((this.state.scale - 1) * -1) / 2) * this.imageRef.current.clientWidth &&
            this.currentPosition.y + offset.y < ((this.state.scale - 1) / 2) * this.imageRef.current.clientHeight &&
            this.currentPosition.y + offset.y > (((this.state.scale - 1) * -1) / 2) * this.imageRef.current.clientHeight
          ) {

            this.currentPosition.x += e.movementX;
            this.currentPosition.y += e.movementY;
          }

          this.imageRef.current.style.transform = this.translateRotateToSkew(this.currentPosition.x, this.currentPosition.y);
        }
        else if (this.state.rotationNumber == 2 || this.state.rotationNumber == 4) {
          if (this.currentPosition.x + offset.x < ((this.state.scale - 1) / 2) * this.imageRef.current.clientHeight &&
            this.currentPosition.x + offset.x > (((this.state.scale - 1) * -1) / 2) * this.imageRef.current.clientHeight &&
            this.currentPosition.y + offset.y < ((this.state.scale - 1) / 2) * this.imageRef.current.clientWidth &&
            this.currentPosition.y + offset.y > (((this.state.scale - 1) * -1) / 2) * this.imageRef.current.clientWidth
          ) {

            this.currentPosition.x += e.movementX;
            this.currentPosition.y += e.movementY;
          }

          this.imageRef.current.style.transform = this.translateRotateToSkew(this.currentPosition.x, this.currentPosition.y);
        }
      }




    }
  }

  onImageContainerMouseOut = () => {
    this.setState({ imageMove: false })
  }


  render() {
    const { images, openedImageIndex } = this.props;

    return (
      <Modal className='photo-slide-show-modal' onMount={this.onModalMount} closeOnDimmerClick={false} closeIcon size='large' open={openedImageIndex > -1} onClose={() => this.closeModal()}>
        <Modal.Header>

          <div>{`${openedImageIndex + 1} of ${images.length}`}  </div>

        </Modal.Header>
        <Modal.Content className="img-content">
          <div className="grabbable" ref={this.imageContainerRef} onPointerDown={this.onImageContainerMouseDown} onPointerUp={this.onImageContainerMouseUp} onPointerMove={this.onImageContainerMouseMove} onPointerOut={this.onImageContainerMouseOut}>
            <img src={`${images[openedImageIndex] && images[openedImageIndex].URL}`} ref={this.imageRef} />
          </div>

          {/* {<GlassMagnifier
            imageSrc={`${images[openedImageIndex] && images[openedImageIndex].URL}`}
            mouseActivation={MOUSE_ACTIVATION.DOUBLE_CLICK} // Optional
            touchActivation={TOUCH_ACTIVATION.DOUBLE_TAP} // Optional
            className={'rotate' + this.state.rotationNumber}

          />} */}



        </Modal.Content>
        <Modal.Actions className="modal-action">
          <Button icon='redo' onClick={() => this.handleOnRotationClick()} />
          <Button icon='zoom' onClick={() => this.handleZoomIn()} />
          <Button icon='zoom-out' onClick={() => this.handleZoomOut()} disabled={this.state.zoomoutDisabled} />
          <Button content='Prev' icon='left arrow' labelPosition='left' onClick={() => this.previousImage()} disabled={openedImageIndex == 0} />
          <Button content='Next' icon='right arrow' labelPosition='right' onClick={() => this.nextImage()} disabled={openedImageIndex == (images.length - 1)} />


          {/*<Button negative onClick={() => this.closeModal()}>Close</Button>*/}
        </Modal.Actions>
      </Modal>
    )
  }
}



export default PhotoSlideShow;